import { defineMessages } from 'react-intl';

export const i18n: {
	closeDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closeDate: {
		id: 'search-page.filters.names.closeDate',
		defaultMessage: 'Close date',
		description: 'Label for filtering by close date',
	},
});
